import React from "react";
import Modal from 'react-bootstrap/Modal';
import Button from "react-bootstrap/Button";

export default function Info(props){
    return (
        <Modal
            {...props}
            size="lg"
            aria-labelledby="contained-modal-title-vcenter"
            centered
        >
            <Modal.Header style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}>
                <Modal.Title id="contained-modal-title-vcenter">
                    Case {props.case.reference_no}
                </Modal.Title>
            </Modal.Header>
            <Modal.Body style={{
                display: "grid",
                gridTemplateColumns: "33% 33% 33%",
            }}>
                {new Array(
                    ["Reference Number", props.case.reference_no],
                    ["ID Number", props.case.patient_id],
                    ["First Name", props.case.patient_firstname],
                    ["Last Name", props.case.patient_lastname],
                    ["Phone Number", props.case.patient_phone],
                    ["Patient Date of Birth", props.case.patient_dob],
                    ["Address", props.case.patient_add],
                    ["Town", props.case.patient_town],
                    ["Province", props.case.patient_province],
                    ["Date Received", props.case.date_received],
                    ["Date Assigned", props.case.date_assigned],
                    ["Date Completed", props.case.date_completed],
                    ["Appointment Date", props.case.appointment_date],
                    ["Appointment Time", props.case.appointment_time],
                    ["Test Type", props.case.test_type],
                    ["Test Details", props.case.test_details],
                    ["Feedback Status", props.case.feedback_status],
                    ["Feedback Message", props.case.feedback_message],
                   
                ).map((prop, index)=>{                 
                    return (
                        <div key={index} className="property">
                            <div className="label">{prop[0]}</div>
                            <div className="value">{prop[1]}</div>
                        </div>
                    )
                })}
            </Modal.Body>
            <Modal.Footer>
                <Button onClick={props.onHide}>Close</Button>
            </Modal.Footer>
        </Modal>
    );
}